import { sanitizeForUrl } from '../routing/generate-url';

/**
 * Possible CompaniesTable `companyId` values to try for a company profile URL segment.
 * Jobs (including Työmarkkinatori) may use display names, mixed case, or slugified forms.
 */
export function buildCompanyProfileCompanyIdCandidates(routeSlug: string): string[] {
  const raw = routeSlug.trim();
  if (!raw) return [];

  const nfc = raw.normalize('NFC');
  const variants = new Set<string>();

  const add = (s: string) => {
    const t = s.trim();
    if (t) variants.add(t);
  };

  add(raw);
  add(nfc);
  add(raw.toLowerCase());
  add(nfc.toLowerCase());

  const sanitized = sanitizeForUrl(raw);
  if (sanitized) add(sanitized);
  const sanitizedNfc = sanitizeForUrl(nfc);
  if (sanitizedNfc) add(sanitizedNfc);

  return [...variants];
}
